module.exports = __webpack_public_path__ + "static/media/wallpaper2.cd620013.jpg";